// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=d8bc9918-fdac-4880-aa9f-3914fe30c91c";
};